module.exports = __webpack_public_path__ + "img/about04.cbcf0243.png";